import React from "react";
import { createRoot } from "react-dom/client";
import OrderCheckWidget from "components/order/OrderCheckWidget";

// Mounts the inline ID-verification review widget into any container the
// order meta box rendered (see includes/Hooks/Orders.php meta_box_html).
// This entry deliberately avoids Polaris so it never injects global CSS onto
// the WooCommerce order edit screen.
function mountAll() {
  document.querySelectorAll(".real-id-order-check").forEach((el) => {
    if (el.dataset.realIdMounted === "1") {
      return;
    }
    el.dataset.realIdMounted = "1";
    createRoot(el).render(
      <OrderCheckWidget
        checkId={el.dataset.checkId}
        orderId={el.dataset.orderId}
        detailsUrl={el.dataset.detailsUrl}
      />
    );
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mountAll);
} else {
  mountAll();
}

// HPOS order screens hydrate parts of the DOM with JavaScript, so the meta box
// container can appear after initial load. Watch for it and mount when ready.
const observer = new MutationObserver(() => {
  if (document.querySelector(".real-id-order-check:not([data-real-id-mounted])")) {
    mountAll();
  }
});
observer.observe(document.body, { childList: true, subtree: true });
